import React from 'react';
import { AlertTriangle } from 'lucide-react';

const MapError: React.FC = () => {
  return (
    <div className="w-full h-full flex items-center justify-center bg-red-50 dark:bg-red-900/20 rounded-lg">
      <div className="text-center">
        <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-red-700 dark:text-red-400">
          Error al cargar el mapa
        </h3>
        <p className="text-red-600 dark:text-red-300">
          No se pudo cargar el mapa. Por favor, intente nuevamente.
        </p>
      </div>
    </div>
  );
};

export default MapError;